import React from 'react';
import PropTypes from 'prop-types';
import CardChartInfo from '../CardChartInfo';
import SimpleLineChart from '../Charts/Widgets/SimpleLineChart';
import { LoaderFull } from '../../Loader';
import * as Style from './style';

const StatisticCharts = ({
    impressions, clicks, timeline, ctr,
}) => {
    const graphRender = () => {
        if (!timeline.error) {
            return timeline.data.length !== 0
                ? (<SimpleLineChart data={timeline.data} />)
                : (
	<div className="d-flex align-items-center" style={{ minHeight: '300px', height: '100%' }}>
		<LoaderFull />
	</div>
                );
        }
        return (
	<div className="d-flex align-items-center justify-content-center" style={{ minHeight: '300px', height: '100%' }}>
		<span style={{ textAlign: 'center' }}>Algo saiu errado. <br />Por favor, tente novamente mais tarde</span>
	</div>
        );
    };

    const dataRender = info => (info === null);

    return (
	<>
		<Style.BoxChartContainer>
			<Style.BoxChart>
				<CardChartInfo
					label="Cliques"
					isLoading={dataRender(clicks.data)}
					amount={clicks.data}
					hasPlan
					error={clicks.error}
					tooltipText="Quando alguém clica no seu anúncio ele é contabilizado aqui."
					tooltipId="clicks"
				/>
			</Style.BoxChart>
			<Style.BoxChart>
				<CardChartInfo
					label="Impressões"
					isLoading={dataRender(impressions.data)}
					amount={impressions.data}
					hasPlan
					error={impressions.error}
					tooltipText="É a quantidade de vezes que seu anúncio é exibido no canal. Vale lembrar que o mesmo usuário pode visualizar mais de uma vez no feed de notícias, contabilizando mais impressões."
					tooltipId="impressions"
				/>
			</Style.BoxChart>
			<Style.BoxChart>
				<CardChartInfo
					label="CTR"
					isLoading={dataRender(ctr.data)}
					amount={ctr.data}
					hasPlan
					error={ctr.error}
					tooltipText="É o número de pessoas que viram sua publicação."
					tooltipId="ctr"
				/>
			</Style.BoxChart>
		</Style.BoxChartContainer>
		<Style.ChatsContainer>
			{graphRender()}
		</Style.ChatsContainer>
	</>
    );
};

PropTypes.StatisticCharts = {
	impressions: PropTypes.object.isRequired, 
	clicks: PropTypes.object.isRequired, 
	timeline: PropTypes.object.isRequired, 
	ctr: PropTypes.object.isRequired, 
};

export default StatisticCharts;
